module.exports = __webpack_public_path__ + "static/media/our-values-awards-1.f37a7bcd.png";